import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';

const renderChart: ThemeUICSSObject = {
  height: '100%',
  margin: '2px',
  // overflow: 'hidden',
  '&.withBorder': (theme) => {
    return {
      border: '2px solid',
      borderColor: theme.palette.darkenColor('primary', 10),
    };
  },

  '.closeButton': {
    variant: 'buttons.icon',
    position: 'absolute',
    right: '10px',
    top: '10px',

    padding: 0,
    width: '2em',
    height: '2em',
  },

  '.closeButtonList': {
    variant: 'buttons.icon',
    right: '10px',
    top: '10px',

    padding: 0,
    width: '2em',
    height: '2em',
  },

  '.scaleCombo': {
    width: '200px',
  },

  '.verticalBarsChart': {
    '.bar': {
      cursor: 'pointer',
    },
  },

  svg: {
    shapeRendering: 'optimizeSpeed',
    textRendering: 'optimizeSpeed',
    colorRendering: 'optimizeSpeed',
  },

  wrapper: {
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    '.chartRenderer__innerWrapper': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      '.closeButton': {
        alignSelf: 'end',
      },
      '.chartTitle': {
        display: 'flex',
        justifyContent: 'space-between',
        padding: spacing(3),
        paddingLeft: spacing(5),
        backgroundColor: 'palette.secondary.light',
        color: 'palette.primary.contrastText',
      },
      '&>div:not(.chartTitle)': {
        height: 'inherit',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
      },
    },
    '.chart__chartRenderer': (theme) => {
      return {
        width: '100%',
        height: '100%',
        padding: 0,
        position: 'relative',
        borderTop: '1px solid',
        overflowY: responsive({ 0: 'scroll', 3: 'auto' }),
        borderTopColor: theme.palette.darkenColor(theme.palette.border.ghost),
        '.chartContainer': {
          padding: '0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingY: responsive({ 0: 3, 3: 0 }),
          width: responsive({ 0: 'auto', 3: '75%' }),
          height: responsive({ 0: 'auto', 3: '100%' }),
        },
        '.chartLegend__Wrapper': {
          width: responsive({ 0: '100%', 3: '25%' }),
          display: 'flex',
          backgroundColor: responsive({
            0: 'transparent',
            3: 'palette.secondary.light',
          }),
          flexDirection: responsive({ 0: 'row', 3: 'column' }),
          height: responsive({ 0: 'auto', 3: '100%' }),
          position: 'absolute',
          gap: spacing(3),
          right: responsive({ 0: 'auto', 3: 0 }),
          top: responsive({ 0: 'auto', 3: 0 }),
          paddingTop: spacing(3),
          paddingLeft: spacing(3),
          borderLeft: '1px solid',
          borderLeftColor: theme.palette.darkenColor(
            theme.palette.border.ghost,
          ),
          justifyContent: responsive({ 0: 'space-around', 3: 'flex-start' }),
          '.chart__combo__wrapper': {
            marginBottom: spacing(5),
            h6: {
              color: 'palette.text.primary',
              paddingBottom: spacing(4),
            },
          },
          '.chart__legend__wrapper': {
            marginBottom: spacing(5),
            overflowY: responsive({ 0: 'auto', 3: 'scroll' }),
            h6: {
              color: 'palette.text.primary',
              paddingBottom: spacing(4),
            },
          },
        },
      };
    },
  },
  '.modal__headerBar': {
    height: '100% !important',
  },

  '.listChart': {
    marginTop: '60px',
  },
};

export default renderChart;
